import { ErrorHandler, inject, Injectable } from '@angular/core';

import { isChunkLoadError, reloadForStaleChunks } from '@core/utils/chunk-reload';

import { LogService } from '../log/log';

@Injectable()
export class AppErrorHandler implements ErrorHandler {
  private readonly logService = inject(LogService);

  handleError(error: any): void {
    if (isChunkLoadError(error)) {
      console.warn('[AppErrorHandler] Chunk load failed — reloading app');
      if (!reloadForStaleChunks()) {
        // The guard already spent its reload this window, so the failure is not a stale client
        this.logService.exception(error, '[AppErrorHandler] Chunk load failure persisted after reload');
      }
      return;
    }

    this.logService.exception(error, '[AppErrorHandler] Unhandled error');
    console.error(error);
  }
}
